import React, { useState } from 'react';
import LitImage from './images/LitImage';
import { useEffect } from 'react';

const CustomerReviewCard = ({
  key,
  review,
  image,
  logo,
  total,
  onToggleExpand,
  isHomePage,
}) => {
  const [open, setOpen] = useState(false);
  const text = review.text;

  useEffect(() => onToggleExpand && onToggleExpand(), [open]);

  return (
    <div className="review-card" key={key}>
      <div className="review-card-top-container">
        <div className="review-card-img">
          <LitImage image={image} alt="Icon" />
        </div>
        <p className="review-card-created">{review.createdAt}</p>
      </div>
      <div className="review-container">
        {onToggleExpand ? (
          <p className="review-content">
            {open
              ? `"${text}"`
              : `"${text.substring(0, isHomePage ? 100 : 60)}..."`}
          </p>
        ) : (
          <p className="review-content">{text}</p>
        )}{' '}
        {onToggleExpand && (
          <button
            className="read-more collapsible"
            onClick={() => {
              setOpen(!open);
            }}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            title={open ? '- Read Less' : '+ Read more'}
            aria-label={open ? '- Read Less' : '+ Read more'}
          >
            {open ? '- Read Less' : '+ Read more'}
          </button>
        )}
      </div>
      <a
        className="review-name"
        href={`https://uk.trustpilot.com/reviews/${review.id}`}
        target="_blank"
        aria-label={review.consumer.displayName}
        title={review.consumer.displayName}
      >
        {review.consumer.displayName}
      </a>
    </div>
  );
};

export default CustomerReviewCard;
